var map = {
	"./1200-mk5-fair.png": "f614",
	"./1200-plain.png": "1e8a",
	"./1210-black-mk7.png": "3cd3",
	"./1210-fair.png": "97fa",
	"./45-puck.png": "57ae",
	"./slipmat-a-trans.png": "3d5a",
	"./slipmat-c.png": "3bb0",
	"./stylus-c-trans.png": "abec",
	"./stylus-trans-bb.png": "096b",
	"./stylus-trans-cc.png": "ac68",
	"./tonearm-black.png": "06b6",
	"./tonearm-silver.png": "fd61",
	"./tonearm-straight-black.png": "fa04",
	"./tonearm-straight.png": "d6cc",
	"./weight-a.png": "9ced",
	"./weight-b-.png": "0480",
	"./weight-c.png": "1150"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec85";